<template>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header p-0 mb-50 mx-auto">
                    <a class="go-back" @click="$router.go(-1)" >{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                </div>
                <div class="card-content">
                    <div class="row match-height">
                        <div class="col-xl-12 col-lg-12">
                            <div class="card">
                                <div class="card-body">
                                    <div>
                                        <div class="row">
                                            <div class="col-xl-3 col-md-3 col-12">
                                                <div class="form-group">
                                                    <label for="lexisnexis-address">
                                                        LexisNexis Address
                                                    </label>
                                                    <select
                                                        v-model="creditBureaus['LexisNexis'].selected_address"
                                                        class="form-control"
                                                        id="lexisnexis-address"
                                                        required
                                                        @change="updateLetter()"
                                                    >
                                                    <option v-for="(address, value) in creditBureaus['LexisNexis'].addresses" :value="address.id">
                                                        {{ address.street }}, {{ address.city }}, {{ address.state_abbreviation }} {{ address.zipcode }}
                                                    </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-xl-3 col-md-3 col-12">
                                                <label for="attach-document">Attach Document</label>
                                                <div style="padding-top: 18px;padding-bottom: 18px;" class="form-group display-box">
                                                    <div class="custom-control custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            id="append_affidavit"
                                                            name="append_affidavit"
                                                            value="1"
                                                            v-model="checkbox"
                                                        />
                                                        <label class="custom-control-label" for="append_affidavit">
                                                            ID Theft Affidavit
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <editor
                                            id="lexisNexis"
                                            v-model="letters.lexisNexis"
                                            :api-key="settingStore.tinymce.api_key"
                                            :init="settingStore.tinymce.configuration"
                                        />
                                    </div>
                                    <div class="d-flex justify-content-center my-1">
                                        <button class="btn btn-sm-block btn-primary" @click.once="submit" type="button" name="editorType" value="1">
                                            {{ localizationStore.translate("letter.left.submit.button.text") }}
                                        </button>
                                        <button
                                            id="letter-rewrite"
                                            class="btn btn-outline-primary ml-1"
                                            @click="spin"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("spin.letter.button.text") }}
                                            <b-popover
                                                target="letter-rewrite"
                                                placement="top"
                                                triggers="hover"
                                                :html="true"
                                            >
                                                <template #title>
                                                    {{ localizationStore.translate("chat.pricing.title") }}
                                                </template>
                                                <div class="row">
                                                    <div class="col-12">
                                                        <p v-if="planStore.openAI.serviceCharges.type == planStore.openAI.serviceCharges.fixed">
                                                            {{ localizationStore.translate("chat.pricing.message", { credit: planStore.getPrice('letter_rewrite') }) }}
                                                        </p>
                                                        <p v-else>
                                                            {{ localizationStore.translate("chat.pricing.dynamic.message") }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </b-popover>
                                        </button>
                                        <button
                                            data-toggle="modal"
                                            data-target="#chat-modal"
                                            class="btn btn-outline-primary mx-1"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("chat.button.title") }}
                                        </button>
                                        <button
                                            data-toggle="modal"
                                            data-target="#top-up-modal"
                                            class="btn btn-outline-primary"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("spin.purchase.button.text") }}
                                        </button>
                                    </div>
                                    <div class="row">
                                        <spinner ref="spinner" :user-info='userInfo' :editor-ref='editorRef' />
                                    </div>
                                    <div ref="lexisNexis" hidden>
                                        <p>
                                            {{ date }}
                                        </p>
                                        <p>
                                            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
                                            <br />{{ userStore.user.address }} {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
                                        </p>
                                        <p>
                                            {{ creditBureaus['LexisNexis'].address_name }} <br />
                                            {{ _.find(creditBureaus['LexisNexis'].addresses, { 'id': creditBureaus['LexisNexis'].selected_address }).street }} <br />
                                            {{ _.find(creditBureaus['LexisNexis'].addresses, { 'id': creditBureaus['LexisNexis'].selected_address }).city }}, {{ _.find(creditBureaus['LexisNexis'].addresses, { 'id': creditBureaus['LexisNexis'].selected_address }).state_abbreviation }} {{ _.find(creditBureaus['LexisNexis'].addresses, { 'id': creditBureaus['LexisNexis'].selected_address }).zipcode }}
                                        </p>
                                        <div class="page">
                                            <p>
                                                I am writing to request that LexisNexis place a security freeze on my credit file. As you are aware, applying a security
                                                freeze prohibits LexisNexis Risk Solutions and SageStream from releasing my LexisNexis Consumer Disclosure Report, my
                                                SageStream Consumer Report, or my credit score without my express authorization.
                                            </p>
                                            <p class="letter-content">
                                                Enclosed are copies of the following documents that verify my identity:
                                                <br />
                                                <ul>
                                                    <li>Photo ID</li>
                                                    <li>Social Security Card</li>
                                                </ul>
                                            </p>
                                            <p>Please send me written confirmation of the security freeze to the address listed above.</p>
                                            <p style="page-break-after: always;">
                                                Sincerely, <br> <br>
                                                {{ userStore.user.firstname }} {{ userStore.user.lastname }}<br />
                                            </p>
                                        </div>
                                        <div class="page-content">
                                            <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
                                            <p style="padding-top:3rem; text-align: center;">
                                                <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
                                                <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
                                            </p>
                                            <p v-if='userStore.user.address_verify_image_url'>
                                                <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { useLetterStore } from '../../stores/LetterStore.js'
    import { usePlanStore } from '../../stores/PlanStore.js'
    import { useSettingStore } from '../../stores/SettingStore.js'
    import moment from 'moment';
    import Editor from '@tinymce/tinymce-vue'
    import { BPopover } from 'bootstrap-vue-3'
    export default {
        props: {
            creditBureaus: {
                type: [Array, Object]
            },
            userInfo: {
                type: [Array, Object]
            },
        },
        components: {
            'editor': Editor
        },
        setup(props) {
            let creditBureaus = [];
            _.forEach(props.creditBureaus, function(creditBureau) {
                creditBureaus[_.get(creditBureau, 'name')] = creditBureau;
            });
            return {
                creditBureaus: reactive(creditBureaus),
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                localizationStore: useLocalizationStore(),
                letters: reactive({
                    lexisNexis: null
                }),
                editorRef: ref(null),
                routes:ref([]),
                userInfo:reactive({}),
                letterStore:useLetterStore(),
                planStore: usePlanStore(),
                settingStore: useSettingStore(),
                checkbox:ref(false),
                _: _,
            };
        },
        watch: {
            'userStore.user'(value) {
                if (value != null) {
                    this.userInfo = value
                }
            },
        },
        mounted() {
            const $this = this;
            const letterSpinUrl = this.$router.resolve({
                name: 'spin-letter',
            });
            $this.routes = {
                'letterSpinUrl':letterSpinUrl.href
            };
            if(!_.isEmpty($this.userStore.user)){
                $this.userInfo = $this.userStore.user
                $this.email = $this.userStore.user.email;
                if (!$this.reportStore.reports[this.email]) {
                    $this.reportStore.getReport();
                }
            }else{
                $this.userStore.fetchUser();
            }
            this.$nextTick().then(() => {
                setTimeout(() => {
                    this.letters.lexisNexis = this.$refs.lexisNexis && this.$refs.lexisNexis.innerHTML;
                }, 3000);
            });
        },
        methods: {
            submit() {
                const route = this.$router.resolve({
                    name: 'create-letter',
                    params: {
                        letter: this.$route.params.letter,
                        client: this.$route.params.client,
                        team: this.$route.params.team,
                    }
                }),
                $this = this,
                payload = {
                    multipe_letters: true,
                    letters: []
                };
                payload.letters.push({
                    letter_id: $this.letterStore.getId($this.$route.params.letter),
                    credit_bureau_name: $this.creditBureaus['LexisNexis'].name,
                    letter_preview: tinymce.get('lexisNexis').getContent(),
                    append_affidavit : $this.checkbox,
                    addressable_id: $this.creditBureaus['LexisNexis'].selected_address,
                });
                axios.post(route.href, payload)
                .then(function (response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    toastr.success(response.data.message, 'Success!');
                    setTimeout(() => {
                        if($this.userStore.user.isDIY){
                            $this.$router.push({ name: 'disputes-report' });
                            return;
                        }
                        window.location.href = response.data.data.url;
                    }, 3000)
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            spin() {
                this.$refs.spinner.spin(tinymce.get('lexisNexis'))
            },
            changeCheckbox(){
                this.checkbox = !this.checkbox
            },
            updateLetter() {
                this.letters.lexisNexis = this.$refs.lexisNexis.innerHTML;
            },
        }
    };
</script>
